(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/javascripts/api-calls/result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/javascripts/api-calls/result.js');

'use strict';

const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
async function fetchResult(product, drawNumber) {
  try {
    var _resp$response$result, _resp$response;
    const resp = await drawgamesApiCaller.getDrawProductDrawsResult({
      product: productMapping.getProductDrawId(product),
      drawNumber
    });
    return (_resp$response$result = resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.result) !== null && _resp$response$result !== void 0 ? _resp$response$result : resp === null || resp === void 0 ? void 0 : resp.result;
  } catch (e) {
    svs.lyckoplatsen.logger.info('Failed to get result', e);
  }
}
Object.assign(svs.lyckoplatsen.components.shared_result.api_calls, {
  fetchResult
});

 })(window);